import {LiveStreamingTileDefaultBox} from "./live-streaming-tile.default.box";

export const LiveStreamingTileBox = LiveStreamingTileDefaultBox;
